'use strict';

const NEWS_TYPES = {
  ALL: {
    ID: -1,
  },
  NOMINATION: {
    ID: 2,
  },
  DEPARTURE: {
    ID: 3,
  },
  BIRTHDAY: {
    ID: 4,
  },
  FUNDRAISER: {
    ID: 5,
  },
  CONFERENCE: {
    ID: 6,
  },
  SPEAKER: {
    ID: 7,
  },
  BUSINESS_SIGNAL: {
    ID: 11,
  },
  PRESS: {
    ID: 12,
  },
  NEW_CONTACT: {
    ID: 13,
  },
  EXTERNAL_GROWTH: {
    ID: 14,
  },
  BUSINESS_DEVELOPMENT: {
    ID: 15,
  },
  NEW_WEBSITE: {
    ID: 16,
  },
  DIVERSIFICATION: {
    ID: 17,
  },
  MARKETING_PROJECT: {
    ID: 18,
  },
  INTERNATIONAL_DEVELOPMENT: {
    ID: 19,
  },
  DIGITAL_PROJECT: {
    ID: 20,
  },
  IT_PROJECT: {
    ID: 21,
  },
  RESEARCH_INVESTMENT: {
    ID: 22,
  },
  COMPANIES_IN_TROUBLE: {
    ID: 23,
  },
  HIRING: {
    ID: 24,
  },
  CAR_FLEET: {
    ID: 25,
  },
  CALL_TENDERS_TRAINING: {
    ID: 26,
  },
  VEHICLE_SERVICE: {
    ID: 28,
  },
  FUNDRAISING: {
    ID: 29,
  },
  CALL_TENDERS_IT: {
    ID: 30,
  },
  CALL_TENDERS_MARKETING: {
    ID: 31,
  },
};

const ELIGIBLE_NEWS_TYPE_ID_LIST_FOR_ACCOUNT = [
  NEWS_TYPES.NOMINATION.ID,
  NEWS_TYPES.DEPARTURE.ID,
  NEWS_TYPES.SPEAKER.ID,
  NEWS_TYPES.PRESS.ID,
  NEWS_TYPES.BUSINESS_SIGNAL.ID,
  NEWS_TYPES.EXTERNAL_GROWTH.ID,
  NEWS_TYPES.BUSINESS_DEVELOPMENT.ID,
  NEWS_TYPES.NEW_WEBSITE.ID,
  NEWS_TYPES.DIVERSIFICATION.ID,
  NEWS_TYPES.MARKETING_PROJECT.ID,
  NEWS_TYPES.INTERNATIONAL_DEVELOPMENT.ID,
  NEWS_TYPES.DIGITAL_PROJECT.ID,
  NEWS_TYPES.IT_PROJECT.ID,
  NEWS_TYPES.RESEARCH_INVESTMENT.ID,
  NEWS_TYPES.COMPANIES_IN_TROUBLE.ID,
  NEWS_TYPES.HIRING.ID,
  NEWS_TYPES.CAR_FLEET.ID,
  NEWS_TYPES.CALL_TENDERS_TRAINING.ID,
  NEWS_TYPES.VEHICLE_SERVICE.ID,
  NEWS_TYPES.FUNDRAISING.ID,
  NEWS_TYPES.CALL_TENDERS_IT.ID,
  NEWS_TYPES.CALL_TENDERS_MARKETING.ID,
];

const NEWS_BUSINESS_OPPORTUNITY_TYPES = {
  EXTERNAL_GROWTH: {
    ID: 1,
  },
  BUSINESS_DEVELOPMENT: {
    ID: 2,
  },
  NEW_WEBSITE: {
    ID: 3,
  },
  DIVERSIFICATION: {
    ID: 4,
  },
  MARKETING_PROJECT: {
    ID: 5,
  },
  INTERNATIONAL_DEVELOPMENT: {
    ID: 6,
  },
  DIGITAL_PROJECT: {
    ID: 7,
  },
  IT_PROJECT: {
    ID: 8,
  },
  RESEARCH_INVESTMENT: {
    ID: 9,
  },
  COMPANIES_IN_TROUBLE: {
    ID: 10,
  },
  HIRING: {
    ID: 11,
  },
  CAR_FLEET: {
    ID: 14,
  },
  VEHICLE_SERVICE: {
    ID: 15,
  },
  FUNDRAISING: {
    ID: 16,
  },
  CALL_TENDERS_IT: {
    ID: 17,
  },
  CALL_TENDERS_MARKETING: {
    ID: 18,
  },
};

const NEWS_CONSTANTS = {
  ELIGIBLE_NEWS_TYPE_ID_LIST_FOR_ACCOUNT,
  NEWS_BUSINESS_OPPORTUNITY_TYPES,
  NEWS_TYPES,
};

export {
  NEWS_CONSTANTS,
};
